import React, { useEffect, useMemo, useState } from "react";
import "../css/SectionNav.css";

export default function SectionNav({ sections = [], offset = 110 }) {
  const sectionIds = useMemo(
    () => sections.filter((s) => s?.id).map((s) => s.id),
    [sections]
  );

  const [active, setActive] = useState(sectionIds[0] || "");
  const [scrolled, setScrolled] = useState(false);

  const scrollTo = (id) => {
    const el = document.getElementById(id);
    if (!el) return;

    const top = el.getBoundingClientRect().top + window.scrollY - offset;
    window.scrollTo({ top, behavior: "smooth" });
  };

  useEffect(() => {
    if (!sectionIds.length) return;

    const onScroll = () => {
      setScrolled(window.scrollY > 5);

      let current = sectionIds[0];

      for (const id of sectionIds) {
        const el = document.getElementById(id);
        if (!el) continue;

        const rect = el.getBoundingClientRect();
        if (rect.top <= offset + 20 && rect.bottom >= offset + 20) {
          current = id;
          break;
        }
      }

      setActive(current);
    };

    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, [sectionIds, offset]);

  if (!sections.length) return null;

  return (
    <div className={`section-nav ${scrolled ? "scrolled" : ""}`}>
  <div className="section-nav-inner">
    <div className="section-nav-pills">
      {sections.map((s, idx) => {
        if (s.type === "phone") {
          return (
            <a key={`phone-${idx}`} className="top-ui-phone" href={s.href}>
              {s.label}
            </a>
          );
        }

        if (!s.id) return null;

        return (
          <a
            key={s.id}
            href={`#${s.id}`}
            className={`section-nav-link ${active === s.id ? "active" : ""}`}
            onClick={(e) => {
              e.preventDefault();
              scrollTo(s.id);
            }}
          >
            {s.label}
          </a>
        );
      })}
    </div>
  </div>
</div>
  );
}
